import { postJson, getJson, setAuthInfo, clearAuthInfo } from "./baseApiClient";

export async function login(userName: string, password: string) {
  const rval = await postJson("/api/v1/account/login", {
    authRequired: false,
    body: {
      userName,
      password,
    },
  });
  if (rval.success) {
    setAuthInfo(rval.result);
  }
  return rval;
}

export function logout() {
  clearAuthInfo();
}

export async function getAuthenticationStatus() {
  return await getJson("/api/v1/account/status", {
    authRequired: true,
  });
}

export async function register(
  firstName: string,
  lastName: string,
  email: string,
  //phoneNumber: string,
  userName: string,
  password: string
) {
  const rval = await postJson("/api/v1/account/register", {
    authRequired: false,
    body: {
      userName,
      firstName,
      lastName,
      email,
      //phoneNumber,
      password,
    },
  });

  return rval;
}

export async function recover(userName: string) {
  const rval = await postJson("/api/v1/account/recover", {
    authRequired: false,
    body: {
      userName,
    },
  });

  return rval;
}

export async function resetPassword(
  userId: string,
  token: string,
  password: string
) {
  const rval = await postJson("/api/v1/account/reset-password", {
    authRequired: false,
    body: {
      userId,
      token,
      password,
    },
  });

  return rval;
}

export async function confirm(userId: string, token: string) {
  const rval = await postJson("/api/v1/account/confirm-email", {
    authRequired: false,
    body: {
      userId,
      token,
    },
  });

  return rval;
}

export async function invite(userId: string, token: string) {
  const rval = await postJson("/api/v1/account/invite", {
    authRequired: false,
    body: {
      userId,
      token,
    },
  });

  return rval;
}

export async function confirmInvite(userId: string, token: string) {
  const rval = await postJson("/api/v1/account/confirm-invite", {
    authRequired: false,
    body: {
      userId,
      token,
    },
  });

  return rval;
}

export async function getProfile() {
  const rval = await getJson(`/api/v1/user/-`, {
    authRequired: true,
  });

  return rval;
}

export async function updateProfile(
  userId: string,
  userName: string,
  firstName: string,
  lastName: string,
  email: string,
  phoneNumber: string
) {
  const rval = await postJson(`/api/v1/user/${userId}`, {
    authRequired: true,
    body: {
      userName,
      firstName,
      lastName,
      email,
      phoneNumber,
    },
  });

  return rval;
}
